import { classNamePrefix as prefixCt } from "@/utils/common";
import "./index.less";

export default class mentionRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("mention")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    node.removeAttribute("data-type");
    const uid = node.getAttribute("data-uid");
    const isSelf = this.config.userId && uid === this.config.userId;
    if (isSelf) node.classList.add("myself");
  };
}
